import React, { useState } from "react";
import VoiceImage from "./VoiceImage";
import { SecondaryButton, toast } from "@jammable/ui-core";
import { Spinner } from "@jammable/ui-components/Loader";
import { requireIdToken } from "../utils/firebaseAuth";
import axios from "axios";
import { useQueryClient } from "react-query";
import {
  FaPlus,
  FaMinus,
  FaHeart,
  FaPlay,
  FaChartLine,
  FaUser,
} from "react-icons/fa";
import { MdVerified } from "react-icons/md";
import { BsStars } from "react-icons/bs";
import { Badge } from "@jammable/ui-components/Badge";
import millify from "millify";
import Image from "next/image";

const AddVoiceItem = ({
  voice,
  collection,
  collectionVoices,
  setCollectionVoices,
}) => {
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  const isAdded = collectionVoices.some((model) => model.modelId === voice._id);
  const [isHovered, setIsHovered] = useState(false);

  const handleAddRemove = async () => {
    const token = await requireIdToken();
    setLoading(true);
    if (collectionVoices.some((model) => model.modelId === voice._id)) {
      setCollectionVoices(
        collectionVoices.filter((model) => model.modelId !== voice._id),
      );
    } else {
      setCollectionVoices([
        ...collectionVoices,
        { modelId: voice._id, modelName: voice.artistname },
      ]);
    }
    axios
      .post(
        "/api/collection/addModelToCollection",
        { collectionId: collection._id, modelId: voice._id },
        { headers: { Authorization: token } },
      )
      .then(async (res) => {
        toast.success(res.data.message);
        queryClient.invalidateQueries(["collectionVoices", collection._id]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div
      key={voice._id}
      className={`tw-flex tw-cursor-pointer tw-items-center tw-w-full tw-max-w-full tw-gap-3 tw-transition-all tw-duration-300 tw-rounded-2xl tw-p-2 tw-px-0 tw-justify-between `}
    >
      <div className="tw-relative">
        <VoiceImage
          model={voice}
          size={60}
          className="tw-rounded-2xl tw-shadow-sm"
        />
      </div>

      <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full tw-truncate">
        <div className="tw-flex tw-items-center tw-gap-1">
          <div className="tw-font-black tw-text-lg tw-truncate">
            {voice.artistname}
          </div>
        </div>

        <div className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-black/40 tw-truncate tw-w-full">
          <div className="tw-flex tw-items-center tw-gap-1  tw-text-sm tw-truncate">
            {voice.user.avatar ? (
              <Image
                src={voice.user.avatar}
                alt={voice.user.username}
                width={20}
                height={20}
                className="tw-rounded-full"
              />
            ) : (
              <FaUser size={12} />
            )}
            <span className="tw-font-medium tw-truncate">
              {voice.user.username}
            </span>
          </div>
          <div className="tw-flex tw-items-center tw-gap-1">
            <FaPlay size={12} />
            <span className="tw-font-medium">{millify(voice.uses)}</span>
          </div>
          <div className="tw-flex tw-items-center tw-gap-1">
            <FaHeart size={15} />
            <span className="tw-font-medium">
              {voice?.likes?.toLocaleString()}
            </span>
          </div>
        </div>
      </div>

      <SecondaryButton
        onClick={handleAddRemove}
        className={`tw-rounded-full tw-px-4 tw-w-24 tw-font-black tw-text-xs tw-h-10 tw-flex tw-items-center tw-gap-2 tw-transition-all tw-bg-purple-50 tw-text-purple-600 tw-border-purple-200 hover:tw-bg-purple-100`}
        disabled={loading}
      >
        {loading ? (
          <Spinner className={"tw-border-purple-600 tw-border-3"} size={4} />
        ) : isAdded ? (
          "REMOVE"
        ) : (
          "ADD"
        )}
      </SecondaryButton>
    </div>
  );
};

export default AddVoiceItem;
